import { render, staticRenderFns } from "./simOpenTnPUp.vue?vue&type=template&id=5c93b8ee&scoped=true&"
import script from "./simOpenTnPUp.vue?vue&type=script&lang=js&"
export * from "./simOpenTnPUp.vue?vue&type=script&lang=js&"
import style0 from "./simOpenTnPUp.vue?vue&type=style&index=0&id=5c93b8ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c93b8ee",
  null
  
)

export default component.exports